/* istanbul ignore file */
export * from './CategoryFilterNavigationMobile';
